var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 8C1.66675 8 4.00008 4 8.00008 4C12.0001 4 14.3334 8 14.3334 8C14.3334 8 12.0001 12 8.00008 12C4.00008 12 1.66675 8 1.66675 8Z",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 9.86712C9.0309 9.86712 9.86663 9.03139 9.86663 8.00046C9.86663 6.96952 9.0309 6.13379 7.99997 6.13379C6.96904 6.13379 6.1333 6.96952 6.1333 8.00046C6.1333 9.03139 6.96904 9.86712 7.99997 9.86712Z",
    stroke: "#6B7280",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.48d0a83ef482c6407b14790a86b11b32.svg";
export { ForwardRef as ReactComponent };